var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3184 227.273C87.6624 226.247 88.4156 223.804 90.3641 223.804L193.637 223.804C195.585 223.804 196.338 226.247 194.682 227.273C162.512 247.218 121.489 247.218 89.3184 227.273ZM66.893 208.309C67.2686 208.734 67.8105 208.975 68.3781 208.975L215.623 208.975C216.19 208.975 216.733 208.734 217.108 208.308C220.25 204.749 223.095 201.02 225.645 197.153C226.504 195.85 225.551 194.146 223.99 194.146L60.0106 194.146C58.4497 194.146 57.4969 195.85 58.356 197.153C60.9054 201.02 63.7511 204.749 66.893 208.309ZM48.544 178.055C48.8372 178.819 49.5749 179.316 50.3933 179.317L233.608 179.317C234.426 179.317 235.164 178.819 235.457 178.055C236.858 174.404 238.037 170.687 238.995 166.925C239.311 165.681 238.359 164.487 237.075 164.488L46.9262 164.487C45.6418 164.487 44.6895 165.681 45.0064 166.925C45.9639 170.687 47.1432 174.404 48.544 178.055ZM44.0417 149.658C42.9949 149.658 42.123 148.851 42.0641 147.806C40.5148 120.334 50.2341 92.345 71.2218 71.3573C110.312 32.2674 173.689 32.2673 212.779 71.3573C233.767 92.3449 243.486 120.334 241.937 147.806C241.878 148.851 241.006 149.658 239.959 149.658L44.0417 149.658Z",
    fill: "#222326"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0.579102 142) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.9c41eed537301ab150ad85976ef8fb21.svg";
export { ForwardRef as ReactComponent };